import { _ as t, A as n, au as e, f as o, a8 as s, h as a, ao as i, ab as r, e as l, a as u, av as c, aw as h, Q as p, M as d, w as f, b as _, c as v, ai as m, t as g, S as I, g as w, ax as y, u as U, am as T, V as k, U as b } from "./__bundle-75942676.js";
var P = function (o) {
    function s(t) {
      var s = t.title,
        a = t.optionTexts,
        i = t.data,
        r = t.allowUserSuggestion,
        l = t.allowMultipleVotes,
        u = t.closeAt,
        c = o.call(this) || this;
      return c.method = n.POST, c.path = e, c.params = {
        title: s,
        options: a,
        data: i,
        allow_user_suggestion: r,
        allow_multiple_votes: l,
        close_at: u
      }, c;
    }
    return t(s, o), s;
  }(o),
  x = function (n) {
    function e(t, e) {
      var o = n.call(this, t, e) || this;
      return o.poll = new s(t, e), o;
    }
    return t(e, n), e;
  }(a),
  O = function (o) {
    function s(t) {
      var s = t.channelUrl,
        a = t.channelType,
        i = t.pollId,
        r = o.call(this) || this;
      return r.method = n.GET, r.path = "".concat(e, "/").concat(encodeURIComponent(i)), r.params = {
        channel_url: s,
        channel_type: a
      }, r;
    }
    return t(s, o), s;
  }(o),
  S = function (n) {
    function e(t, e) {
      var o = n.call(this, t, e) || this;
      return o.poll = new s(t, e), o;
    }
    return t(e, n), e;
  }(a),
  q = function (o) {
    function s(t) {
      var s = t.channelUrl,
        a = t.channelType,
        i = t.pollId,
        r = t.pollOptionId,
        l = o.call(this) || this;
      return l.method = n.GET, l.path = "".concat(e, "/").concat(encodeURIComponent(i), "/options/").concat(encodeURIComponent(r)), l.params = {
        channel_url: s,
        channel_type: a
      }, l;
    }
    return t(s, o), s;
  }(o),
  L = function (n) {
    function e(t, e) {
      var o = n.call(this, t, e) || this;
      return o.pollOption = new i(t, e), o;
    }
    return t(e, n), e;
  }(a),
  C = function (e) {
    function o(t) {
      var o = t.channelType,
        s = t.channelUrl,
        a = t.timestamp,
        i = t.token,
        u = e.call(this) || this;
      return u.method = n.GET, u.path = "".concat(r(o), "/").concat(encodeURIComponent(s), "/polls/changelogs"), u.params = l({
        change_ts: a,
        token: i
      }), u;
    }
    return t(o, e), o;
  }(o),
  M = function (n) {
    function e(t, e) {
      var o = n.call(this, t, e) || this;
      return o.updatedPolls = e.updated.map(function (n) {
        return function (t, n) {
          return new s(t, n);
        }(t, n);
      }), o.deletedPollIds = e.deleted.map(function (t) {
        return t;
      }), o.hasMore = e.has_more, o.nextToken = e.next, o;
    }
    return t(e, n), e;
  }(a),
  Q = {
    title: "",
    optionTexts: [],
    data: void 0,
    allowUserSuggestion: void 0,
    allowMultipleVotes: void 0,
    closeAt: -1
  },
  E = function E(t) {
    return u("string", t.title) && c(t.optionTexts) && h(t.data) && u("boolean", t.allowUserSuggestion, !0) && u("boolean", t.allowMultipleVotes, !0) && u("number", t.closeAt, !0);
  },
  A = {
    channelUrl: "",
    channelType: p.BASE,
    pollId: 0,
    pollOptionId: 0
  },
  G = function G(t) {
    return u("string", t.channelUrl) && "" !== t.channelUrl && d(p, t.channelType) && u("number", t.pollId) && t.pollId > 0 && u("number", t.pollOptionId) && t.pollOptionId > 0;
  },
  N = {
    channelUrl: "",
    channelType: p.BASE,
    pollId: 0
  },
  R = function R(t) {
    return u("string", t.channelUrl) && "" !== t.channelUrl && d(p, t.channelType) && u("number", t.pollId);
  },
  V = {},
  B = function () {
    function t(t, n) {
      var e = n.sdkState,
        o = n.dispatcher,
        s = n.sessionManager,
        a = n.requestQueue,
        i = n.logger;
      this._iid = t, this._sdkState = e, this._sessionManager = s, this._requestQueue = a, this._dispatcher = o, this._logger = i, V[t] = this;
    }
    return t.of = function (t) {
      return V[t];
    }, t.prototype.buildPollFromSerializedData = function (t) {
      var n = f(t);
      return new s(this._iid, s.payloadify(n));
    }, t.prototype.get = function (t) {
      return _(this, void 0, void 0, function () {
        var n, e;
        return v(this, function (o) {
          switch (o.label) {
            case 0:
              return g(R(t)).throw(I.invalidParameters), n = new O(w({}, t)), [4, this._requestQueue.send(n)];
            case 1:
              return e = o.sent(), [2, e.as(S).poll];
          }
        });
      });
    }, t.prototype.create = function (t) {
      return _(this, void 0, void 0, function () {
        var n, e;
        return v(this, function (o) {
          switch (o.label) {
            case 0:
              return g(E(t)).throw(I.invalidParameters), n = new P(w({}, t)), [4, this._requestQueue.send(n)];
            case 1:
              return e = o.sent(), [2, e.as(x).poll];
          }
        });
      });
    }, t.prototype.getOption = function (t) {
      return _(this, void 0, void 0, function () {
        var n, e;
        return v(this, function (o) {
          switch (o.label) {
            case 0:
              return g(G(t)).throw(I.invalidParameters), n = new q(w({}, t)), [4, this._requestQueue.send(n)];
            case 1:
              return e = o.sent(), [2, e.as(L).pollOption];
          }
        });
      });
    }, t.prototype.getPollChangeLogs = function (t, n, e, o) {
      return void 0 === o && (o = m.SYNC_POLL_CHANGELOGS), _(this, void 0, void 0, function () {
        var s, a, i, r, l, u, c;
        return v(this, function (h) {
          switch (h.label) {
            case 0:
              return s = new C(U({
                channelType: n,
                channelUrl: t,
                timestamp: "number" == typeof e ? e : null,
                token: "string" == typeof e ? e : null
              })), [4, this._requestQueue.send(s)];
            case 1:
              return a = h.sent(), i = a.as(M), r = i.updatedPolls, l = i.deletedPollIds, u = i.hasMore, c = i.nextToken, r.length > 0 && this._dispatcher.dispatch(new y({
                polls: r,
                source: o
              })), [2, {
                updatedPolls: r,
                deletedPollIds: l,
                hasMore: u,
                token: c
              }];
          }
        });
      });
    }, t;
  }(),
  j = function j(t, n) {
    this.pollId = 0, this.messageId = 0, this.pollId = n.poll.id, this.messageId = n.poll.message_id, this._iid = t, this._payload = n;
  },
  z = function z(t) {
    this.pollId = 0, this.messageId = 0, this.pollId = t.poll_id, this.messageId = t.message_id, this._payload = t;
  },
  D = function (o) {
    function s(t) {
      var s = t.channelUrl,
        a = t.channelType,
        i = t.token,
        r = t.limit,
        l = o.call(this) || this;
      return l.method = n.GET, l.path = e, l.params = {
        channel_url: s,
        channel_type: a,
        token: i,
        limit: r
      }, l;
    }
    return t(s, o), s;
  }(o),
  F = function (n) {
    function e(t, e) {
      var o,
        a = this;
      return (a = n.call(this, t, e) || this).polls = (null !== (o = e.polls) && void 0 !== o ? o : []).map(function (n) {
        return new s(t, n);
      }), a.token = e.next, a;
    }
    return t(e, n), e;
  }(a),
  H = function (n) {
    function e(t, e) {
      return n.call(this, t, e.channelUrl, e.channelType, e) || this;
    }
    return t(e, n), e.prototype.next = function () {
      return _(this, void 0, void 0, function () {
        var t, n, e, o, s, a;
        return v(this, function (i) {
          switch (i.label) {
            case 0:
              return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, t = k.of(this._iid).requestQueue, n = new D(w(w({}, this), {
                token: this._token
              })), [4, t.send(n)]) : [3, 2] : [3, 5];
            case 1:
              return e = i.sent(), o = e.as(F), s = o.polls, a = o.token, this._token = a, this._hasNext = !!a, this._isLoading = !1, [2, s];
            case 2:
              return [2, []];
            case 3:
              throw I.queryInProgress;
            case 4:
              return [3, 6];
            case 5:
              throw I.invalidParameters;
            case 6:
              return [2];
          }
        });
      });
    }, e;
  }(T),
  Y = function (o) {
    function s(t) {
      var s = t.channelUrl,
        a = t.channelType,
        i = t.pollId,
        r = t.pollOptionId,
        l = t.token,
        u = t.limit,
        c = o.call(this) || this;
      return c.method = n.GET, c.path = "".concat(e, "/").concat(encodeURIComponent(i), "/options/").concat(encodeURIComponent(r), "/voters"), c.params = {
        channel_url: s,
        channel_type: a,
        token: l,
        limit: u
      }, c;
    }
    return t(s, o), s;
  }(o),
  J = function (n) {
    function e(t, e) {
      var o,
        s = this;
      return (s = n.call(this, t, e) || this).voters = (null !== (o = e.voters) && void 0 !== o ? o : []).map(function (n) {
        return new b(t, n);
      }), s.token = e.next, s;
    }
    return t(e, n), e;
  }(a),
  K = function (n) {
    function e(t, e) {
      var o = n.call(this, t, e.channelUrl, e.channelType, e) || this;
      return o.pollId = e.pollId, o.pollOptionId = e.pollOptionId, o;
    }
    return t(e, n), e.prototype._validate = function () {
      return n.prototype._validate.call(this) && u("number", this.pollId) && u("number", this.pollOptionId);
    }, e.prototype.next = function () {
      return _(this, void 0, void 0, function () {
        var t, n, e, o, s, a;
        return v(this, function (i) {
          switch (i.label) {
            case 0:
              return this._validate() ? this._isLoading ? [3, 3] : this._hasNext ? (this._isLoading = !0, t = k.of(this._iid).requestQueue, n = new Y(w(w({}, this), {
                pollId: this.pollId,
                pollOptionId: this.pollOptionId,
                token: this._token
              })), [4, t.send(n)]) : [3, 2] : [3, 5];
            case 1:
              return e = i.sent(), o = e.as(J), s = o.voters, a = o.token, this._token = a, this._hasNext = !!a, this._isLoading = !1, [2, s];
            case 2:
              return [2, []];
            case 3:
              throw I.queryInProgress;
            case 4:
              return [3, 6];
            case 5:
              throw I.invalidParameters;
            case 6:
              return [2];
          }
        });
      });
    }, e;
  }(T);
export { H as P, K as a, B as b, Q as c, N as d, R as e, A as f, G as g, j as h, z as i, E as v };